var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-popover",
    {
      attrs: {
        disabled: _vm.disabled,
        placement: "right-end",
        width: "700",
        "popper-class": "no-padding-popover",
        trigger: "click",
      },
      model: {
        value: _vm.showPopover,
        callback: function ($$v) {
          _vm.showPopover = $$v
        },
        expression: "showPopover",
      },
    },
    [
      !_vm.disabled && _vm.showSelectView
        ? _c("crm-relative", {
            ref: "crmrelative",
            attrs: {
              "crm-type": _vm.crmType,
              action: _vm.relationAction,
              "selected-data": _vm.selectedData,
            },
            on: {
              close: function ($event) {
                _vm.showPopover = false
              },
              changeCheckout: _vm.checkInfos,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "flexbox",
        {
          staticClass: "user-container xh-form-border",
          class: [_vm.disabled ? "is_disabled" : "is_valid"],
          attrs: { slot: "reference", wrap: "wrap" },
          nativeOn: {
            click: function ($event) {
              return _vm.contentClick.apply(null, arguments)
            },
          },
          slot: "reference",
        },
        [
          _vm._l(_vm.dataValue, function (aitem, aindex) {
            return _c(
              "div",
              {
                key: aindex,
                staticClass: "user-item",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.deleteinfo(aindex)
                  },
                },
              },
              [
                _vm._v(_vm._s(_vm.getShowName(aitem)) + "\n      "),
                _c("i", { staticClass: "delete-icon el-icon-close" }),
              ]
            )
          }),
          _vm._v(" "),
          _vm.dataValue.length == 0
            ? _c("div", { staticClass: "add-item" }, [_vm._v("+添加")])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }